import * as PIXI from 'pixi.js';
  import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
  list: [
    {
      id: '07ef257d-cac7-4645-85d1-0e8dfaee1e39',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '230d6d6b-010a-4eb9-a695-c9015c201471',
      type: 'Container',
      name: 'boardContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: '206b8c0b-3953-407d-8384-f0389f72299c',
      type: 'Container',
      name: 'leftSpace',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: '9938e5d8-2856-42d5-a87b-392ea6cbb777',
      type: 'Container',
      name: 'rightSpace',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: 'a7690fb5-67bc-4b4e-b341-bec62bef1446',
      type: 'Container',
      name: 'topSpace',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: '4fa60ea0-851a-46db-b60d-40aa97bd21ed',
      type: 'Sprite',
      name: 'boardBackground',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'BUBBLE_FIELD_BACKGROUND',
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '3677c150-bdc7-4a21-8255-f096839b8277',
      type: 'Container',
      name: 'pointZonesContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: 'ce12abf4-c2c9-4504-b1ea-8c0a5faf484e',
      type: 'Container',
      name: 'bouncersContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '5fda4e81-cdc1-4b80-9819-d1b1164f36b0',
      type: 'Container',
      name: 'deathLineContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: 'b00b9d54-6dc6-407b-885d-1405fbde1815',
      type: 'Container',
      name: 'bubblesGridContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: 'c35c6a1c-e7de-4d21-9bb7-50dad30e26fe',
      type: 'Container',
      name: 'fxAboveGrid',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '1d90b5a5-3463-48d4-a811-dafdb55ece54',
      type: 'Container',
      name: 'bubblesShootedContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '3df02bca-f932-4334-a633-52db1edf57f3',
      type: 'Container',
      name: 'bubblesPopOutContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '8c8f4cf9-6b9e-4def-9040-bb53305de131',
      type: 'Container',
      name: 'shooterPointerContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '89434f65-223f-435d-a68b-a5fd36bb1e20',
      type: 'Container',
      name: 'shooterContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '33bda4ea-fe07-41d4-908b-1f5ae9a265f8',
      type: 'Sprite',
      name: 'soundButton',
      className: '',
      x: 322,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'SOUND_BUTTON',
      parent: 'a7690fb5-67bc-4b4e-b341-bec62bef1446'
    },
    {
      id: '361cbcc3-341a-49c6-a6c6-454b7a5cdf1a',
      type: 'Sprite',
      name: 'soundLabelOn',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'sound_on',
      parent: '33bda4ea-fe07-41d4-908b-1f5ae9a265f8'
    },
    {
      id: 'c1877f47-5353-4469-8243-fbef2c3071d2',
      type: 'Sprite',
      name: 'soundLabelOff',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'sound_off',
      parent: '33bda4ea-fe07-41d4-908b-1f5ae9a265f8'
    },
    {
      id: '33bda4ea-fe07-6666-908b-1f5ae9a265f8',
      type: 'Sprite',
      name: 'pauseButton',
      className: '',
      x: -322,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'SOUND_BUTTON',
      parent: 'a7690fb5-67bc-4b4e-b341-bec62bef1446'
    },
    {
      id: 'c1877f47-5353-4444-8243-fbef2c3071d2',
      type: 'Sprite',
      name: 'pauseLabel',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pause',
      parent: '33bda4ea-fe07-6666-908b-1f5ae9a265f8'
    },
    {
      id: 'c1877f47-5353-3333-8243-fbef2c3071d2',
      type: 'Sprite',
      name: 'resumeLabel',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'resume',
      parent: '33bda4ea-fe07-6666-908b-1f5ae9a265f8'
    },
    {
      "x": 0,
      "y": 385,
      "className": "",
      "pivot": {
        "x": 0.5,
        "y": 0.5
      },
      "anchor": {
        "x": 0.5,
        "y": 0.5
      },
      "scale": {
        "x": 1,
        "y": 1
      },
      "angle": 0,
      "alpha": 1,
      "visible": false,
      "blendMode": 0,
      "interactive": false,
      "hitArea": {
        "type": "None"
      },
      "id": "35fd2c57-248a-1234-8d78-975dda5c293f",
      "buttonMode": false,
      "parent": 'a7690fb5-67bc-4b4e-b341-bec62bef1446',
      "name": "pauseText",
      "type": "Text",
      "text": "Paused",
      "localize": true,
      "maxWidth": 0,
      "maxHeight": 0,
      "maxFontSize": 0,
      "icons": [],
      "style": {
        "fontSize": 88,
        "fontWeight": "normal",
        "fontFamily": "Futura-Bold",
        "fill": "white",
        "stroke": "black",
        "strokeThickness": 0,
        "align": "left",
        "wordWrap": false,
        "wordWrapWidth": 100,
        "breakWords": false,
        "lineHeight": 0,
        "padding": 5,
        "fontStyle": "normal",
        "dropShadow": false,
        "dropShadowAlpha": 1,
        "dropShadowAngle": 0,
        "dropShadowBlur": 0,
        "dropShadowColor": "black",
        "dropShadowDistance": 5,
        "leading": 0,
        "lineJoin": "round",
        "miterLimit": 10,
        "trim": false,
        "textBaseline": "alphabetic",
        "whiteSpace": "pre",
        "fontVariant": "normal",
        "letterSpacing": 0
      }
    }
  ],
  x: 50,
  y: 0,
  width: 730,
  height: 1085,
  handleResize: true
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
  root: boolean;
  boardContainer: boolean;
  leftSpace: boolean;
  rightSpace: boolean;
  topSpace: boolean;
  boardBackground: boolean;
  pointZonesContainer: boolean;
  bouncersContainer: boolean;
  deathLineContainer: boolean;
  bubblesGridContainer: boolean;
  fxAboveGrid: boolean;
  bubblesShootedContainer: boolean;
  bubblesPopOutContainer: boolean;
  shooterPointerContainer: boolean;
  shooterContainer: boolean;
  soundButton: boolean;
  soundLabelOn: boolean;
  soundLabelOff: boolean;
  pauseButton: boolean;
  resumeLabel: boolean;
  pauseLabel: boolean;
  pauseText: boolean;

}>;

class Layout {
  public readonly root: PIXI.Container;
  public readonly boardContainer: PIXI.Container;
  public readonly leftSpace: PIXI.Container;
  public readonly rightSpace: PIXI.Container;
  public readonly topSpace: PIXI.Container;
  public readonly boardBackground: PIXI.Sprite;
  public readonly pointZonesContainer: PIXI.Container;
  public readonly bouncersContainer: PIXI.Container;
  public readonly deathLineContainer: PIXI.Container;
  public readonly bubblesGridContainer: PIXI.Container;
  public readonly fxAboveGrid: PIXI.Container;
  public readonly bubblesShootedContainer: PIXI.Container;
  public readonly bubblesPopOutContainer: PIXI.Container;
  public readonly shooterPointerContainer: PIXI.Container;
  public readonly shooterContainer: PIXI.Container;
  public readonly soundButton: PIXI.Sprite;
  public readonly soundLabelOn: PIXI.Sprite;
  public readonly soundLabelOff: PIXI.Sprite;
  public readonly pauseButton: PIXI.Sprite;
  public readonly pauseLabel: PIXI.Sprite;
  public readonly resumeLabel: PIXI.Sprite;
  public readonly pauseText: PIXI.Text;

  constructor(filter?: Filter) {
    populate(this, raw, filter);
  }
}

export { Layout, Filter, raw };
